import React from 'react'
import './WhyLove.css'
import { CalendarOutlined, TeamOutlined, LikeOutlined } from '@ant-design/icons'
import { Typography, Row, Col, Card } from 'antd'
import { useTranslation } from 'react-i18next'

const { Title, Paragraph } = Typography

interface WhyLoveProps {
    onFootballClick: () => void
    onVolleyballClick: () => void
}

const WhyLove: React.FC<WhyLoveProps> = ({
    onFootballClick,
    onVolleyballClick,
}) => {
    const { t } = useTranslation()

    return (
        <div className="why-container" id="sports">
            <Title className="title" level={2}>
                {t('home.whyLove.title')}
            </Title>

            {/* Icons with Text Row */}
            <div className="icons-box">
                {/* Item 1 */}
                <div className="icon-item">
                    <div className="icon">
                        <CalendarOutlined />
                    </div>
                    <div>
                        <Title className="title" level={4}>
                            {t('home.whyLove.beFlexible.title')}
                        </Title>
                        <Paragraph className="paragraph">
                            {t('home.whyLove.beFlexible.description')}
                        </Paragraph>
                    </div>
                </div>

                {/* Item 2 */}
                <div className="icon-item">
                    <div className="icon">
                        <TeamOutlined />
                    </div>
                    <div>
                        <Title className="title" level={4}>
                            {t('home.whyLove.meetNewPeople.title')}
                        </Title>
                        <Paragraph className="paragraph">
                            {t('home.whyLove.meetNewPeople.description')}
                        </Paragraph>
                    </div>
                </div>

                {/* Item 3 */}
                <div className="icon-item">
                    <div className="icon">
                        <LikeOutlined />
                    </div>
                    <div>
                        <Title className="title" level={4}>
                            {t('home.whyLove.superEasy.title')}
                        </Title>
                        <Paragraph className="paragraph">
                            {t('home.whyLove.superEasy.description')}
                        </Paragraph>
                    </div>
                </div>
            </div>

            {/* Cards Row */}
            <Row className="cards-box" gutter={[24, 24]} justify="center">
                <Col xs={24} sm={12} md={8}>
                    <Card
                        onClick={onFootballClick}
                        cover={
                            <div className="card-image">
                                <img
                                    src="/img/Footballcard.png"
                                    alt={t('common.alt.football')}
                                />
                            </div>
                        }
                    >
                        <Card.Meta
                            title={t('home.whyLove.sports.football.title')}
                            description={t(
                                'home.whyLove.sports.football.description'
                            )}
                        />
                        <Card.Meta
                            className="copy"
                            description={t(
                                'home.whyLove.sports.football.formats'
                            )}
                        />
                    </Card>
                </Col>

                <Col xs={24} sm={12} md={8}>
                    <Card
                        onClick={onVolleyballClick}
                        cover={
                            <div className="card-image">
                                <img
                                    src="/img/Volleyballcard.png"
                                    alt={t('common.alt.volleyball')}
                                />
                            </div>
                        }
                    >
                        <Card.Meta
                            title={t(
                                'home.whyLove.sports.beachVolleyball.title'
                            )}
                            description={t(
                                'home.whyLove.sports.beachVolleyball.description'
                            )}
                        />
                        <Card.Meta
                            className="copy"
                            description={t(
                                'home.whyLove.sports.beachVolleyball.formats'
                            )}
                        />
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default WhyLove
